<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Loader, Text, Token } from '@Shelly/shelly-design-system/index';
	import { real_id } from 'src/helpers/interface_helpers';
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { requestEditDevice } from 'src/components/Lists/list-helpers';

	export let device;
	export let title;

	let waitForResponse = false;
	const id = real_id(device.id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;
	const save = async () => {
		waitForResponse = true;
		let editDevice = {
			...device,
			ht_ui: { unit: selected },
		};
		await requestEditDevice(editDevice);
		waitForResponse = false;
	};

	let selected = settings?.ht_ui?.unit || device?.ht_ui?.unit || 'mm';
</script>

<Text styleType="body-small" class={title ? 'mb-m' : 'mb-s'}>
	{title ||
		$format('text_choose_distance_unit', {
			default: 'Choose distance unit:',
		})}
</Text>

<div class="d-flex">
	{#if waitForResponse}
		<Loader size="m" class="align-self-center" />
	{:else}
		<Token
			id="token-qptmz4h"
			selected={selected === 'mm'}
			size="m"
			title={$format('distance_unit_mm', { default: 'mm' })}
			class="mr-s"
			on:click={() => {
				selected = 'mm';
				save();
			}}
		/>
		<Token
			id="token-2eqmuxo"
			selected={selected === 'cm'}
			size="m"
			title={`${$format('distance_unit_cm', { default: 'cm' })}/${$format('distance_unit_m', { default: 'm' })}`}
			class="mr-s"
			on:click={() => {
				selected = 'cm';
				save();
			}}
		/>
		<Token
			id="token-2infet812"
			selected={selected === 'in'}
			size="m"
			title={`${$format('distance_unit_ft', { default: 'ft' })}/${$format('distance_unit_in', { default: 'in' })}`}
			class="mr-s"
			on:click={() => {
				selected = 'in';
				save();
			}}
		/>
	{/if}
</div>
